module.exports = __webpack_public_path__ + "static/media/Combined_Shape__5_.6dd5966c.svg";